/*
Creates and updates the values of CSS custom properties from DOM measurements
*/
export default class SetCSSProperties {
  constructor() {
    this.ticking = false;

    this.setCSSProperties();
    this.bindResize();
    this.observeAnnouncementBarMutations();
  }

  get header() {
    return document.querySelector("#site-header");
  }

  get announcementBar() {
    return document.querySelector("#announcement-bar");
  }

  setCSSProperties = () => {
    this.ticking = false;

    this.setHeaderHeight();
    this.setAnnouncementBarHeight();
    this.setVwUnit();
  };

  requestTick = () => {
    if (!this.ticking) {
      requestAnimationFrame(this.setCSSProperties);
    }
    this.ticking = true;
  };

  bindResize() {
    window.addEventListener("resize", this.requestTick);
  }

  observeAnnouncementBarMutations() {
    if (!this.announcementBar) return;

    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.attributeName === "hidden")
          this.setAnnouncementBarHeight();
      }
    });

    observer.observe(this.announcementBar, { attributes: true });
  }

  setHeaderHeight = () => {
    if (!this.header)
      return document.documentElement.style.setProperty(
        "--header-height",
        "0px",
      );

    this.header.style.setProperty("position", "fixed");

    const height = this.header.getBoundingClientRect().height;

    document.documentElement.style.setProperty(
      "--header-height",
      `${height}px`,
    );
  };

  setAnnouncementBarHeight = () => {
    if (!this.announcementBar)
      return document.documentElement.style.setProperty(
        "--announcement-bar-height",
        "0px",
      );

    this.announcementBar.style.setProperty("position", "fixed");

    // Safari miscomputes this.announcementBar height, so derive from bar's text block instead
    const text = this.announcementBar.querySelector("[data-ref='text']");
    const height = text.getBoundingClientRect().height;

    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      `${height}px`,
    );
  };

  setVwUnit = () => {
    const viewportWidth = document.documentElement.clientWidth;

    document.documentElement.style.setProperty(
      "--vw",
      `${viewportWidth / 100}px`,
    );
  };
}
